export const HEIGHT_TOP_SIDEBAR_SINGLE_VOYAGE = '56px'
export const ROOT_GAP_SINGLE_VOYAGE = '12px'
export const WIDTH_ROOT_SIDEBAR_SINGLE_VOYAGE = '331px'
export const WIDTH_ROOT_SIDEBAR_SINGLE_VOYAGE_MINI_MODE = '62px'
